export default function map(id, config) {
	var script,
		config = config || {},
		API_KEY = config.API_KEY,
		place = config.place,
		center = config.center || place,
		label = config.title,
		zoom = config.zoom || 15;

	function applyMap() {
		var map = new google.maps.Map(document.getElementById(id), {
			zoom: zoom,
			center: center,
			disableDefaultUI: false,
			scaleControl: true,
			mapTypeControl: false,
			zoomControl: true,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});

		if (label) {
			label = {
				text: config.title,
				fontSize: "14px"
			};
		}

		var marker = new google.maps.Marker({
			position: place,
			map: map,
		    animation: google.maps.Animation.DROP,
			labelClass: "labels",
			label: label
		});
	}


	if (!window.google || !window.google.maps || !window.google.maps.Map) {
		script = document.createElement('script');
		script.setAttribute('src','https://maps.googleapis.com/maps/api/js?key=' + API_KEY + '&callback=initMap');
		script.setAttribute('async','');
		script.setAttribute('defer','');

		document.head.appendChild(script);

		window.initMap = function () {
			applyMap();
		}
	} else {
		applyMap(); // reinitialize map or check if already is ???
	}

}


//////////////////
// WEBPACK FOOTER
// ./src/js/components/map.js
// module id = 5
// module chunks = 0